export const ENV = {
  chargebeeSite: "venuescanner-test",
};
